import { SETTING_ACTIVE_TAB } from "./actionType";

export function setActiveTab(payload) {
  return {
    type: SETTING_ACTIVE_TAB,
    payload,
  };
}
